import ApiService from "../../utils/fetch";
const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}`;

export const createSupportTicket = async (payload) => {
  const url = `${baseUrl}/support/ticket`;
  const response = await ApiService.post(url, payload);
  return response.data;
};

export const fetchTicketSummary = async (loggedInEmail) => {
  const url = `${baseUrl}/support/userSupport/${loggedInEmail}`;
  const response = await ApiService.get(url);
  return response.data;
};
